import React from 'react';
import { Hero } from '../components/Hero';
import { ProofBar } from '../components/ProofBar';
import { PainSection } from '../components/PainSection';
import { MistrBrain } from '../components/MistrBrain';
import { ChannelCards } from '../components/ChannelCards';
import { AskAnything } from '../components/AskAnything';
import { BuiltDifferent } from '../components/BuiltDifferent';
import { HowItWorks } from '../components/HowItWorks';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { StorySection } from '../components/StorySection';
import { IntegrationsPreview } from '../components/IntegrationsPreview';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <main data-id="element-1689" data-mp="31xit3urzyg9a">
      <Hero data-id="element-1690" data-mp="2ea15mbfrm4c4" />
      <ProofBar data-id="element-1691" data-mp="2e9rf8mqt5v5w" />
      <PainSection data-id="element-1692" data-mp="2e97u6x5v2qnn" />
      <MistrBrain data-id="element-1693" data-mp="2e8q0o8al2qjf" />
      <ChannelCards data-id="element-1694" data-mp="2e86gekxgnq28" />
      <AskAnything data-id="element-1695" data-mp="29axzsorynu33" />
      <BuiltDifferent data-id="element-1696" data-mp="29bg488os1em3" />
      <HowItWorks data-id="element-1697" data-mp="299v6ka761fk0" />
      <FeaturesGrid data-id="element-1698" data-mp="29aeq1vcgsc05" />
      <StorySection data-id="element-1699" data-mp="2993om26hrgc7" />
      <IntegrationsPreview data-id="element-1700" data-mp="2ap4ualcl1h1y" />
      <Pricing data-id="element-1701" data-mp="2antusxq66vgn" />
      <FinalCTA data-id="element-1702" data-mp="2aodbkb433dt3" />
    </main>;
}